import { render, staticRenderFns } from "./Trustpilot.vue?vue&type=template&id=2b9815d4"
import script from "./Trustpilot.vue?vue&type=script&lang=js"
export * from "./Trustpilot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports